import SectionBase, * as Section from '@segment/matcha/recipes/Section'
import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'

const copy = {
  title: `Segment for retailers`,
  description: `Bring your store to your customers`,
}

const SegmentForRetailers = () => {
  return (
    <SectionBase variant="noCopy">
      <Section.Contents>
        <CopyTextBase centered={true}>
          <CopyText.Heading variant="h2" tag="h2">
            {copy.title}
          </CopyText.Heading>
          <CopyText.Description tag="p" variant="pLarge">
            {copy.description}
          </CopyText.Description>
        </CopyTextBase>
      </Section.Contents>
    </SectionBase>
  )
}

export default SegmentForRetailers
